<template>
  <el-tree
      :props="props"
      :load="loadNode"
      :node-click="nodeClick"
      :expand-on-click-node="false"
      lazy
      @check-change="handleCheckChange">
      <div style="width:90%" class="custom-tree-node" slot-scope="{ node,data }">
        <span  type="flex" v-show="node.level !== 3">
          <a style="font-size: 16px">{{ node.label }}</a>
        </span>
        <span style="width:90%" v-show="node.level === 3">
          <el-row style="width:90%" class="row-bg" type="flex" justify="space-between">
            <el-col :span="20">
              <a style="font-size: 16px; font-weight: bolder">{{ data.cname }}</a>
              <a style="font-size: 10px; opacity: 0.5">-{{data.teacher}}</a>
            </el-col>
            <el-col :span="4">
              <el-button size="mini" @click="updateCourse(data)" circle
                         :icon="coursesAdded(data)?'el-icon-minus':'el-icon-plus'"/>
              <el-button size="mini" @click="showCourseDetail(data)" circle
                         icon="el-icon-s-opportunity"/>
            </el-col>
          </el-row>
        </span>

      </div>
  </el-tree>
</template>

<script>
import {findDepEnum, findDepGroup} from "@/courseProcessor";

export default {
  name: "all-course-selection",
  data() {
    return {
      props: {
        label: 'cname',
        children: 'child',
        isLeaf: 'leaf'
      },
      count: 1
    };
  },
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },
    handleNodeClick(data) {
      console.log(data);
    },
    loadNode(node, resolve) {
      let deps = findDepEnum(this.allCoursesList)
      let depGroups = findDepGroup(Object.values(deps))
      if (node.level === 0) {
        return resolve(Object.values(depGroups).reverse());
      }
      if (node.level > 3) return resolve([]);

      setTimeout(() => {
        if (node.level === 1) {
          let dgName = node.data.cname
          let dg = depGroups[dgName]
          let returning = dg.child.slice()
          return resolve(returning);
        }
        if (node.level === 2) {
          console.log("Present node level 2")
          let depName = node.data.cname
          let cs = deps[depName].child
          let returning = cs.slice()
          return resolve(returning);
        }
        resolve([]);
      }, 500);
    },
    nodeClick(data, node, nodes) {
      console.log(data)
      console.log(node)
      console.log(nodes)
    }
  }
};
</script>
